<template>
 <div class="header">
    <img
      class="topImg"
      src="../../assets/imgs/apply/topImg.png"
      alt=""
    >
    <div class="content">
      <img
        src="../../assets/imgs/apply/随e贷.png"
        alt=""
      >
    </div>

  </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
.header {
  width: 100%;
  height: 100%;
  background-color: #fff;
  // img {
  //   width: 100%;
  //   height: 100%;
  // }
  .topImg {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
  .content {
    margin-top: -1px;
    width: 1280px;
    margin: auto;
    vertical-align: top;

    img {
      width: 100%;
    }
  }
}
</style> 